<!--
 * @FilePath: /netHallOfficialAccounts/src/App.vue
-->
<template>
  <div id="app">
    <!-- <div v-wechat-title="$route.meta.title"></div> -->
    <router-view />
    <my-footer v-if="showFooter" class="footer" />
  </div>
</template>
<script>
import store from '@/store';
import MyFooter from "@/views/Home/module/myFooter";
import { sysApplicationWhitelist } from '@/api/user.js';

const SHOW_FOOTER = [
  //显示footer的路径
  "/",
  "/BusinessPage/index",
  "/NoticePage/index",
  "/UserCenterPage/index"
];

export default {
  components: {
    MyFooter
  },
  data(){
    return {
      configFlag: false,
      showFooter: true
    }
  },
  computed:{
    token(){
      return store.getters.userInfo?store.getters.userInfo.token : null;
    }
  },
  watch:{
    token:{
      handler(value,old){
          if(value&&!this.configFlag){
            let href = window.location.href;
            this.$getWxApplets(href);
          }
      },
      immediate:true
    },
    $route(to, from) {
      let log = document.getElementById("__vconsole");
      log.style.visibility = 'hidden';
      if (SHOW_FOOTER.includes(to.path)) {
        this.showFooter = true;
      } else {
        this.showFooter = false;
      }
      // if (to.path==='/') {
        sysApplicationWhitelist({
          source: "H5", 
          uniqueId: store.getters.userInfo?store.getters.userInfo.userId : null,
        }).then(res => {
          if (res.resultData) {
            log.style.visibility = 'visible';
          }
        });
      // }
      
    }
  },
  mounted(){
    this.configFlag=false;
    let href = window.location.href;
    let ua = navigator.userAgent;
    let isWx = ua.match(/MicroMessenger/i);
    if(isWx) {
      this.$getWxApplets(href);
    } else {
      console.log('app');
    }
  }
}
</script>
<style>
html,
body {
  height: 100vh;
  margin: 0;
  overflow-y: scroll;
}

::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}
html {
  /* overflow-y: scroll; */
}
body {
  margin: 0;
  padding: 0;
  font-size: 16px;
  background-color: #f6f6f6;
  -webkit-font-smoothing: antialiased;
}
/* 弹出确认框字体调整 */
.van-dialog__cancel,
.van-dialog__confirm {
  font-size: 14px;
}
</style>
